if (!customElements.get('announcement-countdown-timer')) {
  class AnnouncementCountdown extends HTMLElement {
  constructor() {
    super();
    this.userDate = this.getAttribute("data-date");
    this.userTime = this.getAttribute("data-time");
    this.interval;
    this.onInit(this.userDate, this.userTime);
    this.setInterval(this.userDate, this.userTime);
    this.initDiscountButton();
  }
  
    initDiscountButton() {
      const discountButton = this.querySelector('.announcement-countdown__discount-button');
      if (!discountButton) return;
      
      discountButton.addEventListener('click', () => {
        const discountCode = discountButton.getAttribute('data-discount-code');
        
        // Copy to clipboard
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(discountCode).then(() => {
            this.showSuccess(discountButton);
          }).catch(() => {
            this.fallbackCopy(discountCode, discountButton);
          });
        } else {
          this.fallbackCopy(discountCode, discountButton);
        }
      });
    }
    
    showSuccess(button) {
      button.classList.add('copied');
      
      // Remove copied state after 5 seconds
      setTimeout(() => {
        button.classList.remove('copied');
      }, 5000);
    }
    
    fallbackCopy(text, button) {
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      document.body.appendChild(textArea);
      textArea.select();
      
      try {
        document.execCommand('copy');
        this.showSuccess(button);
      } catch (err) {
        console.error('Failed to copy text: ', err);
      }
      
      document.body.removeChild(textArea);
    }
  
    onInit(userDate, userTime) {
      this.daysEl = this.querySelector(".countdown_value_days");
      this.hoursEl = this.querySelector(".countdown_value_hours");
      this.minutesEl = this.querySelector(".countdown_value_minutes");
      
      // Calculate countdown
      const countdownDate = new Date(`${userDate}T${userTime}`);
      const now = new Date();
      const distance = countdownDate.getTime() - now.getTime();
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
      );
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      
      // Hide section if countdown has ended
      if (distance < 0) {
        clearInterval(this.interval);
        this.style.display = "none";
      } else {
        // Update display values
        if (this.daysEl) {
          this.daysEl.textContent = String(days).length === 1 ? '0' + days : days;
        }
        
        if (this.hoursEl) {
          this.hoursEl.textContent = String(hours).length === 1 ? '0' + hours : hours;
        }
        
        if (this.minutesEl) {
          this.minutesEl.textContent = String(minutes).length === 1 ? '0' + minutes : minutes;
        }
      }
    }
  
    setInterval(userDate, userTime) {
      clearInterval(this.interval);
      // Update every 60 seconds since we're not showing seconds
      this.interval = setInterval(
        this.onInit.bind(this, userDate, userTime),
        60000,
      );
    }
  }
  
  customElements.define("announcement-countdown-timer", AnnouncementCountdown);
}

